import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    viewBox="0 0 24 24"
    {...props}
    fill="none"
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5m12-5-4-4m0 0L8 8m4-4v12"
    />
  </Svg>
)
export default SvgComponent
